import styled, { css } from 'styled-components';

interface LabelProps {
  disabled?: boolean;
}

export const Label = styled.label<LabelProps>`
  width: 100%;

  display: flex;
  align-items: center;
  gap: 9px;

  position: relative;
  cursor: pointer;

  border: 1px solid ${({ disabled }) => (disabled ? '#999999' : '#E5E5E5')};
  border-radius: 8px;
  padding: 10px 14px;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  cursor: ${({ disabled }) => disabled && 'not-allowed'};

  color: #999999;

  transition: all 0.2s;
`;

export const Input = styled.input`
  width: 0;
  height: 0;

  position: absolute;
  pointer-events: none;
  opacity: 0;
`;

export const Icon = styled.img`
  width: 34px;
  height: 30px;
`;
